class OkrDetail {
  relationTreeNum = false;
  relationTreeFlag = false;
}
const okrDetail = new OkrDetail();
export default okrDetail;
